export default __webpack_public_path__ + "static/media/youngdaddy.3776c0b5.png";